module.exports = __webpack_public_path__ + "img/pro_eight_2.e9e84964.jpg";